import { ScrollArea as BaseScrollArea } from '@base-ui/react/scroll-area';
import { styled } from '../lib/styled.tsx';

/**
 * Native scrolling with a scrollbar we can style, which the platform ones on
 * macOS and Windows do not agree on. The scrollbar fades in while the pointer is
 * over the area or the content is moving, and stays out of the layout otherwise.
 */
export const ScrollArea = {
  Root: styled(BaseScrollArea.Root, 'relative overflow-hidden'),
  Viewport: styled(BaseScrollArea.Viewport, 'size-full overscroll-contain outline-none'),
  Content: styled(BaseScrollArea.Content, ''),
  Scrollbar: styled(
    BaseScrollArea.Scrollbar,
    'm-0.5 flex touch-none select-none justify-center rounded-full bg-surface-muted p-0.5 ' +
      'opacity-0 transition-opacity duration-200 ' +
      'data-[orientation=vertical]:w-2 data-[orientation=horizontal]:h-2 ' +
      'data-hovering:opacity-100 data-scrolling:opacity-100 data-scrolling:duration-0',
  ),
  Thumb: styled(BaseScrollArea.Thumb, 'rounded-full bg-ink-muted/40'),
  Corner: styled(BaseScrollArea.Corner, 'bg-surface-muted'),
};
